export const SET_MODAL_USER_ID = 'SET_MODAL_USER_ID';
export const SET_ALL_USERS = 'SET_ALL_USERS';
export const SET_MODAL_USER = 'SET_MODAL_USER';
export const SHORTLIST_USER = 'SHORTLIST_USER';
export const SET_GENDER_FILTER = 'SET_GENDER_FILTER';
export const SET_BLOOD_GROUP_FILTER = 'SET_BLOOD_GROUP_FILTER';
export const SET_UNIVERSITY_FILTER = 'SET_UNIVERSITY_FILTER';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
